import React from 'react'

import DetailView from '../components/DetailView'
import { DetailScreenNavigationProp } from '../types'

export default function DetailScreen({ route }: DetailScreenNavigationProp) {
  return (
    <DetailView
      bill={route.params.bill}
      onDone={() => {
        return
      }}
    />
  )
}
